export default __webpack_public_path__ + "static/media/you-can-do-it.6ea88be9.jpg";